import { useEffect, useRef, useState } from "react";
import DeploymentBanner from "./DeploymentBanner";

const DeploymentBannerWithOffset = ({ children }) => {
    const bannerRef = useRef(null);
    const [bannerHeight, setBannerHeight] = useState(0);

    useEffect(() => {
        const el = bannerRef.current;
        if (!el) return;
        const measure = () => setBannerHeight(el.getBoundingClientRect().height);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div ref={bannerRef}>
                <DeploymentBanner />
            </div>
            {children(bannerHeight)}
        </>
    );
};

export default DeploymentBannerWithOffset;
